import { useEffect } from "react";

const DEFAULT_TITLE = "MRQK UK — Digital Services Marketplace";
const LIVE_ORIGIN = "https://marqueukstore.com";

// Public pages get a self-referencing canonical + Open Graph URL on the live domain (www. and preview copies point at it).
const canonicalFor = (pathname) => {
  const host = window.location.hostname;
  const origin = host === "marqueukstore.com" || host === "www.marqueukstore.com" ? LIVE_ORIGIN : window.location.origin;
  return origin + (pathname === "/" ? "/" : pathname.replace(/\/+$/, ""));
};

const setMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    Object.entries(attrs).forEach(([k, v]) => k !== "content" && k !== "href" && el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

export function useSeo({ title, description, jsonLd, image } = {}) {
  const jsonStr = jsonLd ? JSON.stringify(jsonLd) : "";
  const path = window.location.pathname;
  useEffect(() => {
    const url = canonicalFor(path);
    if (title) document.title = title;
    if (description) setMeta('meta[name="description"]', { name: "description", content: description });
    setMeta('link[rel="canonical"]', { rel: "canonical", href: url });
    setMeta('meta[property="og:url"]', { property: "og:url", content: url });
    if (title) {
      setMeta('meta[property="og:title"]', { property: "og:title", content: title });
      setMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    }
    if (description) {
      setMeta('meta[property="og:description"]', { property: "og:description", content: description });
      setMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    }
    if (image) {
      setMeta('meta[property="og:image"]', { property: "og:image", content: image });
      setMeta('meta[name="twitter:image"]', { name: "twitter:image", content: image });
    }
    if (jsonStr) {
      let script = document.getElementById("seo-jsonld");
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "seo-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = jsonStr;
    }
    return () => {
      document.title = DEFAULT_TITLE;
      const s = document.getElementById("seo-jsonld");
      if (s) s.remove();
    };
  }, [title, description, jsonStr, image, path]);
}
